import { formatRelativeWhen } from '../util/format.js';
import { useNow } from '../util/useNow.js';
import type { TimeSpan } from './event-rules.js';

/**
 * How near an event is, as its own leaf.
 *
 * The only thing in the Event section that follows the clock. Subscribing to it
 * from the card would re-render a tile, an avatar and two fixed times every
 * second to move one phrase.
 */
export function Soon({ startsAt, endsAt }: TimeSpan) {
  const now = useNow();
  return <>{formatRelativeWhen(startsAt, endsAt, now)}</>;
}
